module.exports = __webpack_public_path__ + "img/overload.b46d3045.svg";